/**
 * `ai-explanation` capability keys — the EXACT server capability strings
 * (server/src/modules/ai-explanation/routes.js, role Biologiste). useCan / nav gating / ProtectedRoute
 * all key off these. The server re-checks every request; these only hide/disable UI (never the trust
 * boundary). Keep this the single source so screens never inline a raw cap string.
 */
export const AIX_CAPS = {
  /** Read the persisted explanation alongside a signed report (GET /ai/explications/:crId). */
  read: "ai.explication.read",
  /** Generate the explanation for an `emis` compte-rendu (POST /ai/explications/:crId/generer). */
  generate: "ai.explication.generate",
  /** Regenerate — closes the current row → regenere + writes a fresh one (POST .../regenerer). */
  regenerate: "ai.explication.regenerate",
} as const;

export type AixCapability = (typeof AIX_CAPS)[keyof typeof AIX_CAPS];

/**
 * The module gate: the minimum capability to reach any ai-explanation screen. Reading an explanation
 * is the floor; generate/regenerate are gated per-action via useCan.
 */
export const MODULE_CAPS = [AIX_CAPS.read] as const;
